// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"89":"ef4ded15","300":"64502072","461":"0936ab63","557":"ffe9b205","831":"250ec5fd","952":"d2a23e15","972":"9307a2f1"}[chunkId] + ".chunk.css";
};